// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"6151a925","381":"ce6d3cdd","598":"d047b003","928":"95562c20","930":"3cd254dc","961":"adce83d0"}[chunkId] + ".chunk.css";
};